import "lib-flexible";
import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import { Row, Col, Toast } from "vant";
import { UpdateAuth } from "@freshservice/bridge";
import Sentry from "@sh/sentry";
import { IS_PRO } from "@fresh/env";
import { trackPerformance } from "performancetracker";

Vue.use(Row)
  .use(Col)
  .use(Toast);

const sentry = new Sentry({
  release: "1.0.0",
  environment: "production",
  dsn: "https://37bd68359b2f42e58f3cdde35cc5d013@sentry.34580.com/39", // 项目的DSN
  vue: Vue,
  html: true
});
console.log(sentry);

Vue.config.productionTip = false;

// 解决在IOS 10 版本下 禁止双指操作放大缩小的问题
window.onload = function() {
  // 阻止双击放大
  var lastTouchEnd = 0;
  document.addEventListener("touchstart", function(event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  document.addEventListener(
    "touchend",
    function(event) {
      var now = new Date().getTime();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    },
    false
  );

  // 阻止双指放大
  document.addEventListener("gesturestart", function(event) {
    event.preventDefault();
  });
};
// H5 性能监控
document.body.onload = function() {
  try {
    trackPerformance({
      url: IS_PRO
        ? "https://frontendlog-gateway.34580.com/collection/h5/performance/log"
        : "https://frontendlog-gateway-test.34580.com:458/collection/h5/performance/log", // 项目发送地址
      projectId: "shihang-help-center", // 项目名称
      version: "1.0.0" // 项目版本号
    });
  } catch (error) {
    console.error(error);
  }
};

UpdateAuth.init({
  axiosBaseUrl: IS_PRO
    ? "https://api1.34580.com"
    : "https://apitest.34580.com:8043"
})
  .execute()
  .then(() => {
    new Vue({
      router,
      render: h => h(App),
      created() {
        if (!IS_PRO) {
          var VConsole = require("vconsole");
          new VConsole();
        }
      }
    }).$mount("#app");
  });
